(function ($) {
    var tag = document.createElement('script'),
        firstScriptTag = document.getElementsByTagName('script')[0],
        currentVideo = $('#current-video'),
        currentVideoDate = $('#current-video-date'),
        player;

    currentVideo.on('click', function (e) {
        if (e.currentTarget.tagName === 'A') {
            e.preventDefault();
        }
    });

    $('.video-link').on('click', function (e) {
        var data = $(this).data('itemData'),
            title = data.hasOwnProperty('title') ? data.title : '',
            date = data.hasOwnProperty('date') ? data.date : '',
            videoId = data.hasOwnProperty('video_id') ? data.video_id : '',
            header = $('#header');

        e.preventDefault();

        if (currentVideo.data('videoId') !== videoId) {
            if (player.getPlayerState() === 1) {
                player.stopVideo();
            }
            player.loadVideoById(videoId);
            currentVideo.text(title);
            currentVideo.data('videoId', videoId);
            currentVideoDate.html(date);
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#youtube-player').offset().top - (header.position().top + header.height() + 2)
            }, 500);
        }
    });

    window.onYouTubeIframeAPIReady = function () {
        player = new YT.Player('youtube-player', {
            playerVars: {
                controls: 1,
                disablekb: 1,
                enablejsapi: 1,
                modestbranding: 1,
            },
            videoId: currentVideo.data('videoId')
        });
    };

    tag.src = 'https://www.youtube.com/player_api';
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
})(jQuery);
